import type { ActionParams } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { dispatch } from '@swf/core/store';

import defaultHeaderImg from '../../assets/images/default-chest-header.png';
import ChestNotificationView from '../../components/ChestReward/ChestReward';
import { ActionType, FormatType } from '../../enums';
import { launchICEChallenge } from '../../utils/actions';

import {
  TXTCLI_Unlock_Chest,
  TXTCLI_YouXve_been_awarded_a_ChestX,
  TXTMOB_ExpiresX,
  TXTWCL_View_all_Chests
} from './ChestReward.icelocked.config.messages.json';

export default {
  front: {
    view: ChestNotificationView,
    viewConfig: {
      title: { tag: TXTCLI_YouXve_been_awarded_a_ChestX },
      defaultHeaderImageURL: defaultHeaderImg,
      showCloseIcon: true,
      displayAttributes: [
        {
          attrKey: 'expiresOn',
          attrLabel: { tag: TXTMOB_ExpiresX },
          attrFormatterType: FormatType.Date
        }
      ],
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: { tag: TXTCLI_Unlock_Chest },
          actionFunction: ({ attributes, notificationId, history }: ActionParams) => {
            launchICEChallenge({ attributes, history });
            dispatch.notification.delete({ notificationId });
          }
        },
        {
          actionType: ActionType.Secondary,
          actionLabel: { tag: TXTWCL_View_all_Chests },
          href: '/account/my-stars/chest-inventory',
          actionFunction: ({ notificationId }: ActionParams) =>
            dispatch.notification.delete({ notificationId })
        }
      ]
    }
  }
};
